var _style, _g, _path, _path2, _g2, _g3, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnterToGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 946.5 746.6",
    style: {
      enableBackground: "new 0 0 946.5 746.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2E4BC6;}\n\t.st1{fill:#6482FF;}\n\t.st2{fill:#4C598E;}\n\t.st3{fill:#4565ED;}\n\t.st4{opacity:0.1;}\n\t.st5{fill:#536DFE;}\n\t.st6{opacity:0.1;enable-background:new    ;}\n\t.st7{opacity:0.1;fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;enable-background:new    ;}\n\t.st8{fill:#2F2E41;}\n\t.st9{fill:#FFB8B8;}\n\t.st10{fill:#F33C5C;}\n\t.st11{fill:#CE3E61;}\n\t.st12{fill:#2F395B;}\n\t.st13{fill:#E54564;}\n\t.st14{fill:#E2A8B1;}\n\t.st15{fill:#E7DCF9;}\n\t.st16{fill:#EAC81F;}\n\t.st17{fill:#FF3E5F;}\n\t.st18{fill:#F9506C;}\n\t.st19{fill:none;stroke:#535461;stroke-width:2;stroke-miterlimit:10;}\n\t.st20{fill:#FFDE39;}\n\t.st21{fill:#FCD700;}\n\t.st22{fill:#FF4863;}\n\t.st23{fill:#FF5A6A;}\n\t.st24{fill:#F2CD19;}\n\t.st25{fill:#EFCD3F;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "f080dbb7-9b2b-439b-a118-60b91c514f72"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 239.9,
    y: 17.1,
    className: "st0",
    width: 444,
    height: 657
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "562.9,691.1 239.9,674.1 239.9,17.1 562.9,0.1  "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 535.9,
    cy: 377.1,
    r: 4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "535.9,377.7 538.7,382.5 541.4,387.3 535.9,387.3 530.4,387.3 533.1,382.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "576.9,691.1 557.1,691 557.9,0.1 576.9,0.1  "
  }), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "577,691 557,691 558,0 577,0  "
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 535.9,
    cy: 348.1,
    r: 13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 535.9,
    cy: 346.1,
    r: 13
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 292.7,
    y1: 16.1,
    x2: 292.7,
    y2: 677.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 349.7,
    y1: 12.1,
    x2: 349.7,
    y2: 679.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 406.7,
    y1: 9.1,
    x2: 406.7,
    y2: 683
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 463.7,
    y1: 6.1,
    x2: 463.7,
    y2: 687.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 520.7,
    y1: 3.1,
    x2: 520.7,
    y2: 688
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st8",
    cx: 703.1,
    cy: 95.3,
    rx: 39.5,
    ry: 37
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M588.1,325.8l-10,14c0,0-48,10-30,25s44-14,44-14l14-18L588.1,325.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M640.1,166.8c0,0-13,0-16,18s-6,78-6,78s-42,55-35,62s15,20,20,18s48-61,48-61L640.1,166.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M640.1,166.8c0,0-13,0-16,18s-6,78-6,78s-42,55-35,62s15,20,20,18s48-61,48-61L640.1,166.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M680.1,115.8c0,0-1,39-13,41s-8,15-8,15s39,23,65,0l5-12c0,0-18-13-10-31L680.1,115.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M613.1,355.8c0,0-59,110-37,144s55,104,60,104s33-14,31-23s-32-76-40-82s-4-22-3-23s34-54,34-54s-1,84,3,97 s-1,106,4,110s28,11,32,5s16-97,8-118l15-144L613.1,355.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M667.1,622.8l-25,46c0,0-36,26-11,30s40-6,40-6l22-16v-46L667.1,622.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M633.1,596.8l13,31c0,0,5,13,0,16s-19,21-10,23c1.8,0.4,3.7,0.5,5.5,0.5c15.1,0.3,29.7-5.7,40.4-16.4l8.1-8.1 c0,0-27.8-63.9-27.4-63.5C663.1,579.7,633.1,596.8,633.1,596.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 705.1,
    cy: 105.8,
    r: 34
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M724.6,153.3l-10.5,10.5c0,0-32,12-47,0c0,0,5.5-11.5,5.5-10.5s-43.5,7.5-47.5,25.5s3,49,3,49s-28,132-17,135 s114,28,113,9s8-97,8-97l35-67c0,0-5-22-17-29C738.1,171.8,724.6,153.3,724.6,153.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M680.1,348.8l-13,8c0,0-50,34-24,40s41-24,41-24l10-12L680.1,348.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M754.1,201.8l9,9c0,0,6,84-6,101s-67,63-70,60s-22-18-18-20s57.2-57.6,57.2-57.6l-4.2-77.4L754.1,201.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M758.1,198.8l9,9c0,0,6,84-6,101s-67,63-70,60s-22-18-18-20s57.2-57.6,57.2-57.6l-4.2-77.4L758.1,198.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M691.1,57.5c0,0-11.6-4.2-27.3,4.7l8.4,2.1c0,0-12.6,1.1-14.2,17.9h5.8c0,0-3.7,14.7,0,18.9l2.4-4.5l6.8,13.7 l1.6-6.8l3.2,1.1l2.1-11c0,0,5.3,7.9,9.5,8.4v-6.8c0,0,11.6,13.1,15.2,12.6l-5.3-7.4l7.4,1.6l-3.2-5.3l18.9,5.3l-4.2-5.3l13.1,4.2 l6.3,2.6c0,0,8.9-20.5-3.7-34.7C721.3,54.6,702.9,51.5,691.1,57.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 698.5,
    cy: 217.6,
    r: 13.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M377.4,124.8c-0.8,2.4-1.2,5-1.2,7.5c0,2.9,0.5,5.6,1.5,8.1c4.5,12,17.8,18,29.8,13.5c1.2-0.5,2.4-1,3.6-1.7 l0,0c4.6-2.7,8.1-6.9,10-11.8h-20.8V125h37.4c1,5.1,0.9,10.3-0.2,15.4c-1.9,8.8-6.7,16.6-13.7,22.2c-6.9,5.6-15.5,8.6-24.4,8.6 c-21.5,0-38.9-17.4-38.9-38.9c0-6.2,1.5-12.4,4.4-17.9c6.7-12.9,20-21,34.6-21c9.4,0,18.1,3.4,24.8,9l-12.6,10.3 c-10.9-6.8-25.1-3.4-31.9,7.4C378.7,121.6,378,123.2,377.4,124.8z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M745.7,656.9c0,0-0.9,30.7,45.8,3.2c0,0-10.9-19.7-30.8-18.5c-8,0.5-14.5,6.8-15,14.9V656.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M849.3,578c-15.3-6.4-35.6-0.5-47.3,13.6c-29.3,35-8.2,72.2-8.2,72.2c113.3-59.5,56.4-85.5,56.4-85.5 L849.3,578z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M20.4,549.5c0,0-72.2,57,81,111.4c0,0,24.3-62.9-16.9-106.5c-16.5-17.6-43.6-20-63-5.7L20.4,549.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M105.3,663.1c0,0-34.7-77.9-13.2-141.1c9-26.5,9.5-55.1,0.5-81.6c-4.3-12.5-9.8-24.7-16.4-36.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M82,361.6c3.1,9.8-5.7,43.7-5.7,43.7s-26.7-22.8-29.7-32.6c-3.3-9.7,1.9-20.3,11.6-23.6 c9.7-3.3,20.3,1.9,23.6,11.6C81.8,361.1,81.9,361.3,82,361.6L82,361.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M126.5,400.2c-6.8,7.7-40.4,17.7-40.4,17.7s5.8-34.6,12.6-42.3c7-7.5,18.8-7.9,26.3-1 C132.2,381.4,132.8,392.6,126.5,400.2L126.5,400.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M137,503.6c-8.5,5.7-43.6,6.9-43.6,6.9s14.3-32,22.8-37.8c8.6-5.6,20.1-3.1,25.7,5.5 C147.4,486.7,145.2,497.9,137,503.6L137,503.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M128.8,580.5c-7.4,7.1-41.8,14.2-41.8,14.2s8.7-34,16.1-41.1c7.4-7.2,19.1-7,26.3,0.4s7,19.1-0.4,26.3 C128.9,580.4,128.8,580.4,128.8,580.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M50.8,446.7c9.2,4.6,44.1,1.4,44.1,1.4s-18.2-30-27.4-34.6c-9.1-4.8-20.3-1.4-25.2,7.6 c-4.8,9.1-1.4,20.3,7.6,25.2C50.3,446.4,50.5,446.5,50.8,446.7L50.8,446.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M45.1,531.6c9.7,3.4,43.9-4.1,43.9-4.1S67.2,500,57.5,496.6c-9.7-3.2-20.3,2-23.5,11.8 C30.8,517.8,35.7,528.1,45.1,531.6L45.1,531.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M48.5,618c8.9,5,44,3.4,44,3.4s-16.9-30.8-25.8-35.8c-9-5-20.3-1.7-25.3,7.3C36.5,601.8,39.6,613,48.5,618 L48.5,618z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M209.7,520.6c-3.9,6.2-7.2,12.7-9.9,19.5c-5.6,14.3-6.4,30.1-2.3,44.9c9.6,35.4-11.5,77.3-11.5,77.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M215.5,490.2c5.4,1,9,6.2,8.1,11.6c-1,5.4-13.7,19.4-13.7,19.4s-7-17.5-6-23 C204.8,492.8,210,489.2,215.5,490.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M181.8,524.6c-1.9-5.2,0.8-10.9,6-12.8c5.2-1.9,10.9,0.8,12.8,6c2.1,5.1-0.9,23.7-0.9,23.7 s-15.4-10.9-17.5-16C182,525.1,181.9,524.8,181.8,524.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M173.5,576.9c-4-3.3-4.8-9.1-1.9-13.4c3.1-4.5,9.4-5.7,13.9-2.6c4.4,3.3,11.2,20.9,11.2,20.9 S177.9,580.2,173.5,576.9L173.5,576.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M176.2,603.9c3.8-4,10.2-4.1,14.1-0.2c3.8,4,7.5,22.5,7.5,22.5s-18.2-4.8-22-8.8 C172.4,613.4,172.6,607.6,176.2,603.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M220.1,546.2c0.3-0.2,0.5-0.3,0.8-0.5c4.4-3.3,5.4-9.6,2.1-14c-3.3-4.4-9.6-5.4-14-2.1 c-4.6,3.1-12.3,20.3-12.3,20.3S215.4,549.3,220.1,546.2L220.1,546.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M222.1,593.5c4.9-1.7,7.7-6.8,6.5-11.9c-1.3-5.4-6.8-8.6-12.1-7.3c-5.3,1.6-17.8,15.7-17.8,15.7 S216.8,595.1,222.1,593.5L222.1,593.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M222.1,627c-2.2-5-8.1-7.3-13.2-5.1c-4.9,2.4-14.9,18.5-14.9,18.5s18.8,1.9,23.7-0.5 C222.3,637.3,224.3,631.7,222.1,627z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M791.8,661.6c0,0-17.4-59.1,3.3-102.5c8.7-18.2,11.6-38.7,7.5-58.5c-1.9-9.4-4.7-18.6-8.3-27.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M807.2,445.6c0,7.2-13.1,28.2-13.1,28.2s-13.1-21-13.1-28.2c-0.2-7.2,5.6-13.2,12.8-13.4 c7.2-0.2,13.2,5.6,13.4,12.8C807.2,445.2,807.2,445.4,807.2,445.6L807.2,445.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M828.9,485.7c-3.9,6.1-26.3,16.6-26.3,16.6s0.4-24.7,4.3-30.8c3.8-6.2,11.9-8.1,18-4.3 c6.2,3.8,8.1,11.9,4.3,18C829.1,485.3,829,485.5,828.9,485.7L828.9,485.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M827.9,554.2c-6.5,3.3-31.1,1-31.1,1s12.8-21.2,19.3-24.4c6.5-3.1,14.4-0.4,17.5,6.2 C836.6,543.3,834.1,550.9,827.9,554.2L827.9,554.2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M815.5,602.9c-5.8,4.3-30.5,6.2-30.5,6.2s9.1-23,14.9-27.3c5.9-4.3,14.1-3,18.3,2.9 C822.4,590.5,821.2,598.6,815.5,602.9z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M775,503.7c5.2,5,29.4,10.3,29.4,10.3s-5.9-24-11.1-29.1c-5.2-5-13.5-4.9-18.5,0.3S769.8,498.6,775,503.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M761.3,564.3c6.5,3.3,31.1,1,31.1,1s-12.8-21.2-19.3-24.4c-6.5-3.1-14.4-0.3-17.5,6.2 C752.6,553.5,755.1,561,761.3,564.3z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M756,622.1c5.8,4.3,30.5,6.2,30.5,6.2s-9.1-23-14.9-27.3c-5.9-4.3-14.1-3-18.3,2.9 C749.1,609.7,750.3,617.8,756,622.1z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M928.6,657.5c3.1-4.3,2.5-10.2-1.4-13.8c-9.7-8.9-23.4-3.4-23.4-3.4c12.3,33.4,24.6,17.5,24.6,17.5 L928.6,657.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M915.8,663c1.8-3.7-0.4-7.3-5-8.4c-11.5-2.8-23.1,4.9-23.1,4.9c20.6,17.6,28,3.7,28,3.7L915.8,663z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M928.2,669.3c0,0,5.1,12.1,18.4-6.9c0,0-7.7-5.7-15.3-1.7c-3,1.6-4.4,5.2-3.2,8.4L928.2,669.3z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M13,671.1c0,0,5.1,12.1,18.4-6.9c0,0-7.7-5.7-15.3-1.7c-3,1.6-4.4,5.2-3.2,8.4L13,671.1z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M51.3,667.8c-1.6-3-5.3-4.4-8.5-3.1c-8,3.1-8.7,12.7-8.7,12.7c23,2.4,17.2-9.4,17.2-9.4V667.8z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M415.6,723.8c-1.8-5-7-7.8-12.2-6.6c-12.8,2.9-16,17.4-16,17.4c34.6,8.7,28.3-10.5,28.3-10.5L415.6,723.8z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M369,729.9c0,0,5.1,12.1,18.4-6.9c0,0-7.7-5.7-15.3-1.7c-3,1.6-4.4,5.2-3.2,8.4L369,729.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterToGoogle);
export default __webpack_public_path__ + "static/media/enter-to-google.95c3c81bbbe10b86b23be1b26a3d77d9.svg";
export { ForwardRef as ReactComponent };